import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class EmailCampaign extends Model {
  idCampaign: number;
  title?: string;
  description?: string;
  idLanguage: string;
  emailSender: string;
  sender: string;
  replyTo: string;
  companyName: string;
  companyAddress: string;
  url: string;
  companyPhone: string;
  companyFax: string;
  status: string;
  createDate: string;
}

export class EmailCampaignsArray extends Paginated {
  data: Array<EmailCampaign>;
}

export enum EmailCampaignStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  TO_ACTIVATE = 'TO_ACTIVATE'
}

export enum EmailStatusHTMLTagSpan {
  ACTIVE = '<span class="badge badge-active">',
  ARCHIVED = '<span class="badge badge-archived">',
  TO_ACTIVATE = '<span class="badge badge-toactive">'
}

export enum EmailCampaignIdLabel {
  LABEL_ACTIVE = 'mail_campaign_status_active',
  LABEL_ARCHIVED = 'mail_campaign_status_archived',
  LABEL_TO_ACTIVATE = 'mail_campaign_status_toactive'
}

export class EmailSender extends Model {
  emailSender: string;
  idEmailAddress: number;
  isActive: boolean;
  // Is not used for request body
  waitingActivation = false;
}

export class NewEmailCampaign extends Model {
  title?: string;
  description?: string;
  idLanguage: string;
  emailSender: string;
  sender: string;
  replyTo: string;
  companyName: string;
  companyAddress: string;
  url: string;
  companyPhone: string;
  companyFax: string;
}
